import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CustomLog } from '../../custom-classes/CustomLog';
import { DeveloperService } from '../../modules/app/developer.service';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-error-viewer',
  templateUrl: './error-viewer.component.html',
  styleUrls: ['./error-viewer.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDividerModule, CommonModule],
})
export class ErrorViewerComponent implements OnInit {
  @Input() er!: CustomLog[];
  constructor(private developerS: DeveloperService) {}
  ngOnInit(): void {}
  clear() {
    this.developerS.onClearError.next(true);
  }
}
